export default __webpack_public_path__ + "2d71c0a1c905c4fdb49ab222d0f6255a.svg";